import slide1 from '@static/images/features/feature-slide1.jpg'
import slide2 from '@static/images/features/feature-slide2.jpg'
import slide3 from '@static/images/features/feature-slide3.jpg'
import video1 from '@static/videos/features/slide1.webm'
import video2 from '@static/videos/features/slide2.webm'
import video3 from '@static/videos/features/slide3.webm'

const featureSlides = {
  'slide-1': { poster: slide1, video: video1 },
  'slide-2': { poster: slide2, video: video2 },
  'slide-3': { poster: slide3, video: video3 }
}

export default featureSlides
